import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/pages/PageLogin';
import Home from '@/pages/PageHome';
import Cards from '@/pages/PageCards';
import Page404 from '@/pages/Page404';
import Admin from '@/pages/PageAdmin';
import Figer from '@/pages/PageFiger'
import ModifMarge from '@/pages/PageModifALaMarge';
import ModifScenario from '@/pages/PageModifScenario';
import Store from '@/store';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
    },
    {
      path: '/accueil',
      name: 'Home',
      component: Home,
    },
    {
      path: '/admin',
      name: 'Admin',
      component:
        Store.state.userInfos !== null
          ? Store.state.userInfos.isViewer === true
            ? Page404
            : Admin
          : Login,
    },
    {
      path: '/optimisation/figer',
      name: 'optimisationFiger',
      component: Figer,
    },
    {
      path: '/optimisation/modificationalamarge',
      name: 'optimisationModifALaMarge',
      component: ModifMarge,
    },
    {
      path: '/vision-globale',
      name: 'VisionGlobale',
      component: Cards,
      props: {
        links: [
          {
            iframeUrl:
              process.env.VUE_APP_GRAFANA_URL +
              'd/9vRFiEEmk_v3/vision-globale_v3?orgId=1&from=1545360731473&to=1545382331473&var-idoptimisation=',
            cardTitle: 'Avant : Vision globale',
          },
        ],
      },
    },
    {
      path: '/produits',
      name: 'Produits',
      component: Cards,
      props: {
        links: [
          {
            iframeUrl:
              process.env.VUE_APP_GRAFANA_URL +
              'd/fdsfdf/produits_v3?orgId=1&from=1545199286680&to=1545220886680&var-idoptimisation=',
            cardTitle: 'Avant : Produits',
          },
        ],
      },
    },
    {
      path: '/sites',
      name: 'Sites',
      component: Cards,
      props: {
        links: [
          {
            iframeUrl:
              process.env.VUE_APP_GRAFANA_URL +
              'd/HwQkeOLmk_v3/sites_v3?orgId=1&var-idoptimisation=',
            cardTitle: 'Avant : Sites',
          },
        ],
      },
    },
    {
      path: '/clients',
      name: 'Clients',
      component: Cards,
      props: {
        links: [
          {
            iframeUrl:
              process.env.VUE_APP_GRAFANA_URL +
              'd/qENOkKYiz_v3/clients_v3?orgId=1&from=1545361034953&to=1545382634953&var-idoptimisation=',
            cardTitle: 'Avant : Clients',
          },
        ],
      },
    },
    {
      path: '/avant/modificationScenario',
      name: 'avantModifScenario',
      component: ModifScenario,
    },
    {
      path: '/optimisation',
      name: 'Optimisation',
      component: Cards,
      props: {
        links: [
          {
            iframeUrl:
              process.env.VUE_APP_GRAFANA_URL +
              'd/9vRFiEEmkS_v3/vision-globale_v3?orgId=1&from=1545362553614&to=1545384153614&var-idoptimisation=',
            cardTitle: 'Après : Vision Globale',
          },
        ],
      },
    },
    {
      path: '/optimisation/flux-produits',
      name: 'OptimisationFluxProduits',
      component: Cards,
      props: {
        links: [
          {
            iframeUrl:
              process.env.VUE_APP_GRAFANA_URL +
              'd/VVJdt6Yik_v3/flux-produits_v3?orgId=1&from=1545362614189&to=1545384214189&var-idoptimisation=',
            cardTitle: 'Après : Flux Produits',
          },
        ],
      },
    },
    {
      path: '/optimisation/flux-sites',
      name: 'OptimisationFluxSites',
      component: Cards,
      props: {
        links: [
          {
            iframeUrl:
              process.env.VUE_APP_GRAFANA_URL +
              'd/vdOkiJPiz_v3/flux-sites_v3?orgId=1&from=1545362653352&to=1545384253352&var-idoptimisation=',
            cardTitle: 'Après : Flux Sites',
          },
        ],
      },
    },
    {
      path: '/optimisation/taux-de-remplissages',
      name: 'OptimisationTauxDeRemplissages',
      component: Cards,
      props: {
        links: [
          {
            iframeUrl:
              process.env.VUE_APP_GRAFANA_URL +
              'd/HLZGa6Ymk_v3/taux-de-remplissages_v3?orgId=1&from=1545199936982&to=1545221536983&var-idoptimisation=',
            cardTitle: 'Après : Taux de Remplissage',
          },
        ],
      },
    },
    {
      path: '/*',
      name: '404',
      component: Page404,
    },
  ],
});
